import Geometry from 'ol/geom/Geometry';
import VectorImage from 'ol/layer/VectorImage';
import { Options } from 'ol/layer/VectorImage';
import VectorSource from 'ol/source/Vector';
import Style, { StyleLike } from 'ol/style/Style';


export interface OptionsDMTR extends Options{
  styleSelected?:Style | StyleLike
}
export class VectorLayerDMTR extends VectorImage{

  styleSelected?:Style | StyleLike

  constructor(opt_options?: OptionsDMTR){
    super(opt_options);
    this.styleSelected = opt_options?.styleSelected;
  }
  public getStyleSelected():Style | StyleLike{
    return this.styleSelected;
  }

  public getSource():VectorSource{
    return super.getSource() as VectorSource;
  }

}

export interface Layer {
  id: string;
  name: string;
  image: string;
  visible:boolean;
  expanded?: boolean;
  olLayer:VectorLayerDMTR;
  points?: any[];
  navaidid?: string;
}
